import React, { useState, useEffect } from 'react';
import { getServices } from '../api/services';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './ServicesPage.css';

function ServicesPage() {
  const [services, setServices] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    getServices()
      .then((res) => {
        if (res.success) setServices(res.data);
        else setError(true);
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Header />

      {/* Page Banner */}
      <section className="page-banner services-banner">
        <div className="page-banner__overlay">
          <div className="container">
            <h1 className="page-banner__title">Our Services</h1>
            <nav className="breadcrumb">
              <a href="/">Home</a>
              <span>/</span>
              <span>Services</span>
            </nav>
          </div>
        </div>
      </section>

      {/* Intro */}
      <section className="section services-intro">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">What We Offer</span>
            <h2 className="section-title">Comprehensive Landscaping Solutions</h2>
            <p className="section-subtitle">
              From concept to completion, Heaven Green Infra &amp; Landscape delivers premium
              outdoor transformation services across Raipur and Chhattisgarh.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="section services-list-section">
        <div className="container">
          {loading && (
            <div className="sp-loading">
              {[1,2,3,4,5,6].map(i => (
                <div key={i} className="sp-skeleton" />
              ))}
            </div>
          )}

          {error && !loading && (
            <div className="sp-error">
              <p>Unable to load services. Please try again later.</p>
            </div>
          )}

          {!loading && !error && services.length === 0 && (
            <div className="sp-empty">
              <p>Services will be listed here soon.</p>
            </div>
          )}

          {!loading && !error && services.length > 0 && (
            <div className="sp-grid">
              {services.map((service) => (
                <div key={service.id} className="sp-card">
                  {/* Image */}
                  <div className="sp-card__image">
                    {service.image_url ? (
                      <img src={service.image_url} alt={service.title} loading="lazy" />
                    ) : (
                      <div className="sp-card__image-placeholder">
                        <span className="sp-card__icon">{service.icon_class || '🌿'}</span>
                      </div>
                    )}
                    <div className="sp-card__image-overlay" />
                  </div>

                  {/* Content */}
                  <div className="sp-card__body">
                    <div className="sp-card__icon-badge">
                      {service.icon_class || '🌿'}
                    </div>
                    <h3 className="sp-card__title">{service.title}</h3>
                    <p className="sp-card__desc">{service.short_desc}</p>
                    <a href={`/services/${service.slug}`} className="sp-card__link">
                      View Details
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M5 12h14M12 5l7 7-7 7"/>
                      </svg>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA Strip */}
      <section className="section sp-cta-strip">
        <div className="container">
          <div className="sp-cta-strip__inner">
            <div>
              <h3>Ready to Start Your Project?</h3>
              <p>Get a free consultation and quote from our landscape experts.</p>
            </div>
            <div className="sp-cta-strip__actions">
              <a href="/contact" className="btn-primary">Get Free Quote</a>
              <a href="tel:+919981206128" className="btn-secondary">Call Now</a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default ServicesPage;